import pojemnoscSkokowa from '@components/search/inputs/pojemnoscSkokowa'
import mocSilnika from '@components/search/inputs/mocSilnika'
import skrzyniaBiegow from '@components/search/inputs/skrzyniaBiegow'
import napedPojazd from '@components/search/inputs/napedPojazd'

const silnikNaped = { t: 'Silnik i napęd', inputs: [
    pojemnoscSkokowa,
    mocSilnika,
    skrzyniaBiegow,
    napedPojazd,
    { t: 'Kierownica po prawej stronie', type: 'all-checkbox-no-all', name: 'kierownica',
        options: ['Tak', 'Nie'], names: ['kierownica-po-prawej', 'kierownica-po-lewej']}
]}

export default silnikNaped